import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'progress',
    lazy: async () => ({ Component: (await import('./ProgressPage')).ProgressPage }),
  },
];
